










































import Vue from 'vue';

export default Vue.extend({
  name: "MainContent",
  components: {
    MaterialCard: () => import("./MaterialCard.component.vue"),
    RadarChart: () => import("./RadarChart.component.vue"),
    Viewer3D: () => import("./Viewer3D.component.vue"),
    OptionSummary: () => import("./OptionSummary.component.vue"),
  },
    data() {
        return {
            radarTooltipText: '',
            radarTooltip: false,
            tooltipPositionX: 0,
            tooltipPositionY: 0,
            tab: null,
            loading: true,
            imgInfo: require('@/assets/info.png'),
            infoWidth: '24px',
            positionType: 'absolute',
            xPosition: 0,
            yPosition: 0,
            isSystemCostTour: false
    };
  },
  async created() {
    this.loading = false;
  },
    async mounted() {
        this.$root.$on('onRadarTooltip', this.onRadarTooltip);
        this.$root.$on('onUpdateInfo', this.onUpdateInfo);
        this.$root.$on('onSystemCostTour', this.onSystemCostTour); 
    this.startTour();
    },
    async beforeDestroy() { },
    computed: {
        infoLink() {
            return `${this.$timberURL}/user-guide/#costing-assumptions`;
        }
    },
    methods: {
    onSystemCostTour(v) {
            this.isSystemCostTour = v;
    },
    startTour() {
        var ttour = localStorage.getItem('timbertour');
        if (ttour && ttour == 'false') { return; }
        this.$tours["timberTour"].start();
    },
    onRadarTooltip(params) {
        if (!params) {
            this.radarTooltip = false;
            return;
        }
        this.radarTooltipText = params.text;
        this.tooltipPositionX = params.x;
        this.tooltipPositionY = params.y;
        this.radarTooltip = true;
    },
    onUpdateInfo(params) {
        if (!params) {
            return;
        }
        this.xPosition = params.left;
        this.yPosition = params.top;
      }
  },
});
